/** Recovery for the Vite/Netlify "stale chunk" problem. */

const RELOAD_AT_KEY = 'zoe:chunk-reloaded-at';

export const RELOAD_COOLDOWN_MS = 10_000;

const CHUNK_ERROR_RE =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|dynamically imported module|Unable to preload CSS/i;

export function isChunkLoadError(error: unknown): boolean {
  if (!error) return false;
  const message = error instanceof Error ? error.message : String(error);
  return CHUNK_ERROR_RE.test(message);
}

export interface ReloadEnv {
  now: () => number;
  getLastReloadAt: () => number | null;
  setLastReloadAt: (value: number) => void;
  reload: () => void;
}

/** Act on a failed dynamic import. */
export function handleChunkLoadError(error: unknown, env: ReloadEnv): boolean {
  if (!isChunkLoadError(error)) return false;
  const last = env.getLastReloadAt();
  const now = env.now();
  if (last != null && now - last < RELOAD_COOLDOWN_MS) return false;
  env.setLastReloadAt(now);
  env.reload();
  return true;
}

export function browserReloadEnv(): ReloadEnv {
  return {
    now: () => Date.now(),
    getLastReloadAt: () => {
      try {
        const raw = sessionStorage.getItem(RELOAD_AT_KEY);
        if (raw == null) return null;
        const parsed = Number(raw);
        return Number.isFinite(parsed) ? parsed : null;
      } catch {
        return null;
      }
    },
    setLastReloadAt: (value) => {
      try {
        sessionStorage.setItem(RELOAD_AT_KEY, String(value));
      } catch {
        /* private-mode / storage disabled — reload still fires, just unguarded */
      }
    },
    reload: () => window.location.reload(),
  };
}
